import { motion } from 'framer-motion';
import { FC } from 'react';
import ModalDialog from './ModalDialog';

export interface ObjectType {
    [k: string]: string;
}

/**
 * @deprecated
 * Use @RightPopUp
 */

export const SlideFromRightWrapper: FC<{
    closeMe: () => void;
    cssClass?: string;
    transtionTime?: number;
    style?: ObjectType;
    modalOverlayStyle?: ObjectType;
}> = ({ children, closeMe, cssClass, transtionTime = 0.2, style, modalOverlayStyle }) => {
    return (
        <ModalDialog>
            <div>
                <motion.div
                    initial={{ opacity: 0 }}
                    exit={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    style={{ zIndex: 20, ...modalOverlayStyle }}
                    transition={{ duration: transtionTime, ease: 'linear' }}
                    className="modal-overlay"
                    onClick={closeMe}
                ></motion.div>
                <motion.div
                    className={`right-0 top-0 bottom-0 ${
                        cssClass ? cssClass : 'w-736'
                    } h-full fixed`}
                    style={{ zIndex: 100, ...style }}
                    initial={{ right: -1000 }}
                    exit={{ right: -1000 }}
                    animate={{ right: 0 }}
                    transition={{ duration: transtionTime }}
                >
                    {children}
                </motion.div>
            </div>
        </ModalDialog>
    );
};
